import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react";
import { CircularProgress, Grid } from '@mui/material';
import moment from "moment";
import { Fragment, useEffect, useMemo, useState } from 'react';
import toast from "react-hot-toast";
import { obtenerDataImagen } from '../../../../actions/ImagenAction';
import { adaptDatosPrincipales } from "../../../../adapters/contrato/datosPrincipalesAdapter";
import { CustomDialog } from "../../../../components/customDialog/CustomDialog";
import DocumentViewerBase64 from "../../../../components/DocumentViewerBase64";
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { RenderInputsRowByType } from '../../../../components/formGroupGenerator/RenderInputRowByType';
import { CREATE_EVALUACION_DATOS_PRINCIPALES } from "../../../../data/graphQL/mutations/Contratos/CreateEvaluacionDatosPrincipales";
import { DELETE_DOCUMENTO_CONTRATO } from '../../../../data/graphQL/mutations/Contratos/DeleteDocumentoContrato';
import { adaptFinanciador, adaptFinanciadoresArray, GET_ALL_CLIENTES } from "../../../../data/graphQL/queries/Contratos/DatosPrincipales/getAllClientes";
import { adaptCentrosArray, adaptInstitucion, adaptInstitucionesArray, GET_ALL_INSTITUCIONES } from '../../../../data/graphQL/queries/Contratos/DatosPrincipales/getAllInstituciones';
import { GET_BP_CLIENTE } from "../../../../data/graphQL/queries/Contratos/DatosPrincipales/getBPCliente";
import { adaptCanalArray, GET_ALL_CANAL } from '../../../../data/graphQL/queries/Contratos/DatosPrincipales/getCanal';
import { GET_CANAL_BY_INSTITUCION } from "../../../../data/graphQL/queries/Contratos/DatosPrincipales/getCanalByInstitucion";
import { GET_CLIENTE_AUTORIZADOR } from "../../../../data/graphQL/queries/Contratos/DatosPrincipales/getClienteAutorizador";
import { adaptGetDatosPrincipales, GET_DATOS_PRINCIPALES_BY_ID } from "../../../../data/graphQL/queries/Contratos/DatosPrincipales/getEvaluacionById";
import { adaptLugarServicioArray, GET_ALL_LUGAR_SERVICIO } from '../../../../data/graphQL/queries/Contratos/DatosPrincipales/getLugarServicio';
import { GET_PACIENTES } from '../../../../data/graphQL/queries/Contratos/DatosPrincipales/getPacientes';
import { adaptPaciente } from '../../../../data/graphQL/queries/Contratos/DatosPrincipales/getPacientesExistentes';
import { adaptRequisitoCliente, GET_REQUISITO_CLIENTE } from "../../../../data/graphQL/queries/Contratos/DatosPrincipales/getRequisitoClienteByClienteId";
import { adaptUltimaEvaluacion, GET_ULTIMA_EVALUACION } from "../../../../data/graphQL/queries/Contratos/DatosPrincipales/getUltimaEvaluacion";
import { VALIDATE_EXIST_PACIENTE_BY_DNI } from "../../../../data/graphQL/queries/Contratos/DatosPrincipales/validateExistPacienteByDni";
import { VALIDATE_PACIENTE_PE } from "../../../../data/graphQL/queries/Contratos/DatosPrincipales/validatePacientePE";
import { VALIDATE_PACIENTE_PP } from "../../../../data/graphQL/queries/Contratos/DatosPrincipales/validatePacientePP";
import { adaptPacienteSAP, GET_PACIENTE_SAP } from "../../../../data/graphQL/queries/Contratos/DireccionPaciente/getPacienteSAP";
import { PACIENTE_GEOPOSICIONAMIENTO_ACTUALIZADO } from "../../../../data/graphQL/queries/GestionAsistencial/getPacienteGeoActualizada";
import { adaptTipoDocumentoArray, GET_ALL_TIPO_DOCUMENTO } from "../../../../data/graphQL/queries/PacienteProbable/getAllTipoDocumento";
import { GET_PACIENTE_PROBABLE_BY_ID } from '../../../../data/graphQL/queries/PacienteProbable/getPacienteProbableById';
import { normalizeFilterValue } from "../../../../helpers/tools";
import { invariantWithToast } from "../../../../hooks/invariantWithToast";
import { useDebounce } from '../../../../hooks/useDebounce';
import { deepEqualObj } from "../../../../utils/helpers";
import { LUGAR_RI_INTERNACION_ID } from "../Contrato";
import { GroupedContainer } from "../GroupedContainer";
import { CentroDeReferencia } from "./components/CentroDeReferencia";
import { DerivadoInput } from "./components/DerivadoInput";
import { FinanciadorEstado } from "./components/FinanciadorEstado";
import { FinanciadorInput } from "./components/FinanciadorInput";
import { InstitucionInput } from "./components/InstitucionInput";
import { OSSapInput } from "./components/OSSapInput";
import { PacientesExistentes } from "./components/PacientesExistentes";
import './tabDatosPrincipales.scss';

const FINANCIADOR_PARTICULAR = 'A015';
const ESTADO_EVALUACION_PENDIENTE = 3;
const ESTADO_EVALUACION_SUSPENDIDO = 3;

const getIdTipoEvaluacion = (origen) => {
  switch (origen) {
    case 'PE':
      return 1;
    case 'PP':
    case 'US':
      return 2;
    case 'PR':
      return 3;
    case 'USD':
      return 4;
    case 'USN':
      return 5;
    default:
      return 1;
  }
};
const TIPO_AUTORIZACION_NUMERICA = 'Numerico';
const TIPO_AUTORIZACION_DIGITAL = 'Digital';
const TIPO_AUTORIZACION_AMBOS = 'Ambos';
const TIPO_AUTORIZACION_TRADITUM = 'Traditum';
const ID_TIPO_AUTORIZACION_TRADITUM = 3;


export const TabDatosPrincipales = ({
  contratoEditable,
  dataSubmissionRef,
  origen,
  stepData,
  tipoModulo,
  handleChangeFullFormData,
  handleChangeDireccionPaciente,
  setDataSubmissionCallback,
  fullFormData,
  isNew = true,
  idDelegacion,
  idEvaluacion,
  codigoDelegacion,
  nuevoPacienteExistente,
  handleChangeOrigen,
  setIsClientAuthNumeric,
  setIsClientAuthDigital,
  estadosCrediticia,
  idPrePaciente,
  setIsDistinctDelegacion,
  pageLoading,
  setPageLoading,
  cambioDireccion,
  setCambioDireccion,
  stateData
}) => {

  const esNuevoContrato = isNew || nuevoPacienteExistente;
  const phoneRegex = /^\+54(9\d{10}|\d{10,11})$/;


  const idUsuario = sessionStorage.getItem('idUsuario');
  const [datosPrincipales, setDatosPrincipales] = useState(fullFormData?.datosPrincipales || {});
  const [requisitoCliente, setRequisitoCliente] = useState({});
  const [nombreCentro, setNombreCentro] = useState(null);
  const [nombreInstitucion, setNombreInstitucion] = useState(null);
  const [financiador, setFinanciador] = useState(null);
  const [osSAP, setOSSAP] = useState(null);
  const [derivador, setDerivador] = useState(null);
  const [lugarServicioCombo, setLugarServicioCombo] = useState([]);
  const [canalCombo, setCanalCombo] = useState([]);
  const [unicoCanal, setUnicoCanal] = useState(false);
  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [clienteBloqueadoPorSAP, setClienteBloqueadoPorSAP] = useState(false);
  const [clienteAutorizado, setClienteAutorizado] = useState(false);
  const [cambioDeInstitucion, setCambioDeInstitucion] = useState(false);
  const [hasInitialFinanciador, setHasInitialFinanciador] = useState(null);
  const [initialIdInstitucion, setInitialIdInstitucion] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);

  const handleChange = (name, value) => {

    setDatosPrincipales((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));

    if (name === 'idCanal')
      handleChange('detalleCanal', canalCombo?.find((x) => x.id === value)?.detalle);

    if (name === 'idTipoDocumento')
      validarDoc(value);
  };

  const handleChangeDocumentoReal = (value) => {
    handleChange('numeroDocumento', value);
  };

  const onSelectPacienteExistente = (paciente) => {
    const { nameDelegacion, ...pacienteData } = paciente;
    setDatosPrincipales((prevDatos) => ({
      ...prevDatos,
      ...pacienteData
    }));

    handleChangeNDocumento(pacienteData.numeroDocumento);

    getUltimaEval({
      variables: {
        idPaciente: pacienteData.idPaciente
      }
    });
  };

  const [
    pacienteExistente,
    nDocumentoAux,
    openPacExistenteModal,
    handleChangeNDocumento,
    onAcceptPacExistente,
    onDeclinePacExistente,
    validarDoc,
    setNDocumentoAux] =
    useValidateDni(
      handleChangeDocumentoReal,
      datosPrincipales?.idPaciente,
      onSelectPacienteExistente,
      handleChangeOrigen,
      idDelegacion,
      setIsDistinctDelegacion,
      datosPrincipales?.idTipoDocumento
    );

  const [getPacienteSAP] = useLazyQuery(GET_PACIENTE_SAP, {
    fetchPolicy: 'no-cache'
  });

  const [getPacienteGeoActualizada, { data: dataPacienteGeo }] = useLazyQuery(PACIENTE_GEOPOSICIONAMIENTO_ACTUALIZADO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataPacienteGeo) return;
    if (dataPacienteGeo.pacienteGeoposicionActualizada.success && dataPacienteGeo.pacienteGeoposicionActualizada.valorEsperado) {
      setCambioDireccion(false);
    } else {
      handleChange('latitud', '');
      handleChange('longitud', '');
      setCambioDireccion(true);
    }
  }, [dataPacienteGeo]);

  useEffect(() => {
    if (datosPrincipales?.codSAPPaciente) {
      getPacienteSAP({
        variables: {
          codigoSAP: datosPrincipales?.codSAPPaciente,
          idEvaluacion: idEvaluacion
        }
      }).then(({ data }) => {
        if (!!data?.pacienteSAP) {
          const pacienteSAP = adaptPacienteSAP(data.pacienteSAP);
          const datosDireccionPaciente = {
            ...fullFormData?.direccionPaciente,
            codigoSAP: datosPrincipales?.codSAPPaciente,
            latitud: pacienteSAP?.latitud,
            longitud: pacienteSAP?.longitud,
            nombre: pacienteSAP?.nombre,
            direccion: pacienteSAP?.direccion,
            localidad: pacienteSAP?.localidad,
            provincia: pacienteSAP?.provincia,
            codigoPostal: pacienteSAP?.codigoPostal
          };

          handleChangeDireccionPaciente(datosDireccionPaciente);

          // se ejecuta solo no estoy visualizando
          // Contrato no aprobado ni en servicio
          if (contratoEditable &&
            ((stateData.idEstadoEvaluacion === ESTADO_EVALUACION_PENDIENTE) || (stateData.idEstadoEvaluacion === ESTADO_EVALUACION_SUSPENDIDO))
          ) {
            getPacienteGeoActualizada({
              variables: {
                idPaciente: datosPrincipales.idPaciente,
                codPaciente: datosPrincipales?.codSAPPaciente,
                idEvaluacion: idEvaluacion,
              },
            });
          }
        }
      }).catch();
    }
  }, [origen, datosPrincipales?.codSAPPaciente, idEvaluacion]);

  useEffect(() => {
    if (!idEvaluacion) return;

    getDatosPrincipalesById({
      variables: { idEvaluacion }
    });
  }, [idEvaluacion]);

  useEffect(() => {
    if (datosPrincipales['fechaNacimiento'] !== '' && datosPrincipales['fechaNacimiento'] !== null) {
      const edad = calcularEdad(moment(datosPrincipales['fechaNacimiento']).format('"yyyy-MM-DD"'));
      const newValor = edad > 15 ? "Adulto" : "Pediátrico";
      setDatosPrincipales((prevDatos) => ({
        ...prevDatos,
        edad: edad,
        franjaEtarea: newValor
      }));
    }
  }, [datosPrincipales['fechaNacimiento']]);

  const [createEvaluacionDatosPrincipales] = useMutation(CREATE_EVALUACION_DATOS_PRINCIPALES);

  const isValid = () => {
    let errorMessages = [];

    if (!datosPrincipales.nombre || datosPrincipales?.nombre.length === 0) {
      errorMessages.push('Debe ingresar el nombre del paciente.\n');
    }

    if (!datosPrincipales.apellido || datosPrincipales?.apellido.length === 0) {
      errorMessages.push('Debe ingresar el apellido del paciente.\n');
    }

    if (datosPrincipales.telefonoContacto && !phoneRegex.test(datosPrincipales.telefonoContacto.trim())) {
      errorMessages.push('Debe ingresar un télefono de contacto completo con código de país. Ej: +541123456789.\n');
    }

    if (datosPrincipales.familiarTelefono && !phoneRegex.test(datosPrincipales.familiarTelefono.trim())) {
      errorMessages.push('Debe ingresar un télefono de familiar completo con código de país. Ej: +541123456789.\n');
    }

    if (datosPrincipales.numeroDocumento) {
      validarDoc();
    }

    if (errorMessages.length > 0) {
      toast.error(errorMessages.join(' '));
      return false;
    }

    return true;
  };

  const handleSubmit = () => {
    setPageLoading(true);

    if (!isValid()) {
      setPageLoading(false);
      return { error: true };
    }

    const idTipoEvaluacion = getIdTipoEvaluacion(origen);
    const inputDatosPrincipales = adaptDatosPrincipales(
      datosPrincipales,
      idEvaluacion,
      idUsuario,
      idDelegacion,
      idTipoEvaluacion,
      idPrePaciente ? idPrePaciente : datosPrincipales?.idPrePaciente
    );

    createEvaluacionDatosPrincipales({
      variables: { input: inputDatosPrincipales }
    })
      .then(async (res) => {

        if (cambioDeInstitucion && fullFormData?.direccionPaciente?.idLugarRI === LUGAR_RI_INTERNACION_ID) {
          dataSubmissionRef?.current?.direccionPaciente?.callback?.();
        }

        setCambioDeInstitucion(false);

        const newIdEvaluacion = res?.data?.createEvaluacionDatosPrincipales?.idEvaluacion;
        const newIdPaciente = res?.data?.createEvaluacionDatosPrincipales?.idPaciente;

        setDatosPrincipales((prev) => ({
          ...prev,
          idEvaluacion: newIdEvaluacion,
          idPaciente: newIdPaciente
        }));

        if (origen === "US") {
          handleChangeOrigen("PP");
        }

        // ⛔ USAR newIdEvaluacion – NO idEvaluacion (que está viejo)
        try {
          const { data } = await getDatosPrincipalesByIdBis({
            variables: { idEvaluacion: newIdEvaluacion }
          });

          if (!data) return;

          const dp = adaptGetDatosPrincipales(data);

          handleChangeNDocumento(dp.numeroDocumento);

          setDatosPrincipales((prev) => ({
            ...prev,
            ...dp,
            financiadorParticular: dp.codigoRamoCliente == FINANCIADOR_PARTICULAR,
            observacionPrePaciente: dp.observacionPrePaciente
          }));
        } catch (error) {
          if (error?.name !== "AbortError") {
            console.error("Error en getDatosPrincipalesById:", error);
          }
        }
      })
      .catch(() => {
        toast("Error al guardar datos principales");
        return { error: true };
      })
      .finally(() => {
        setPageLoading(false);
      });
  };

  const [deleteDocumento] = useMutation(DELETE_DOCUMENTO_CONTRATO);

  const handleDelete = async (name) => {

    const idArchivo = datosPrincipales.derivacionPrescriptor?.idArchivo;
    try {
      if (!!idArchivo) {
        const response = await deleteDocumento({ variables: { idDocumento: idArchivo } });
        invariantWithToast(!response?.data?.deleteDocumentoContrato, 'Se produjo un error al intentar eliminar el documento');
      }
      handleChange(name);
      handleChange('fechaAltaRP');
    } catch (error) {
      console.error(error);
    }
  };

  const { data: dataLugarServicio, loading: lugarServicioLoading } = useQuery(GET_ALL_LUGAR_SERVICIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataLugarServicio) return;
    setLugarServicioCombo(adaptLugarServicioArray(dataLugarServicio?.allLugarServicio));
  }, [dataLugarServicio]);

  const { data: dataCanal, loading: canaloading } = useQuery(GET_ALL_CANAL, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataCanal) return;
    setCanalCombo(adaptCanalArray(dataCanal?.canal.valorEsperado));
  }, [dataCanal]);

  const { data: dataTipoDocumento, loading: tiposDocLoading } = useQuery(GET_ALL_TIPO_DOCUMENTO);

  useEffect(() => {
    if (!dataTipoDocumento) return;
    setTiposDocumento(adaptTipoDocumentoArray(dataTipoDocumento));
  }, [dataTipoDocumento]);

  const [getRequisitoCliente, { data: dataRequisitoCliente, loading: requisitoClienteLoading }] = useLazyQuery(GET_REQUISITO_CLIENTE, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataRequisitoCliente) return;
    if (dataRequisitoCliente?.requisitoClienteByClienteId) {
      const requisitoAdaptado = adaptRequisitoCliente(dataRequisitoCliente.requisitoClienteByClienteId);
      setRequisitoCliente(requisitoAdaptado);

      const tipoAutorizacion = dataRequisitoCliente.requisitoClienteByClienteId.idTipoAutorizacionNavigation?.descripcion;
      const isNumeric = [TIPO_AUTORIZACION_NUMERICA, TIPO_AUTORIZACION_AMBOS, TIPO_AUTORIZACION_TRADITUM].includes(tipoAutorizacion);
      const isDigital = [TIPO_AUTORIZACION_DIGITAL, TIPO_AUTORIZACION_AMBOS].includes(tipoAutorizacion);

      setIsClientAuthNumeric(isNumeric);
      setIsClientAuthDigital(isDigital);
    } else {
      setIsClientAuthNumeric(false);
      setIsClientAuthDigital(false);
    }
  }, [dataRequisitoCliente]);

  useEffect(() => {
    if (!!datosPrincipales?.idCliente && !datosPrincipales?.financiadorParticular) {
      handleChange('sinInstitucion', false);
    }
  }, [datosPrincipales?.idCliente, datosPrincipales?.financiadorParticular]);

  useEffect(() => {
    if (!!datosPrincipales?.idCliente) {
      getClienteAutorizador({ variables: { idCliente: datosPrincipales?.idCliente } });
      getClienteByCodigo({ variables: { codigo: datosPrincipales?.idCliente } });
      getRequisitoCliente({ variables: { codCliente: datosPrincipales?.idCliente } });

    }
  }, [datosPrincipales?.idCliente]);

  const [
    pacientesRows,
    pacientesTotalCount,
    filterStatus,
    setFilterStatus] =
    useGetPacientes(idDelegacion, origen);

  const [
    centrosRows,
    setCentrosPaginationStatus,
    centrosPaginationStatus,
    centrosTotalCount,
    centrosFilterStatus,
    setCentrosFilterStatus] =
    useGetCentros(idEvaluacion, idDelegacion, datosPrincipales?.idCentroReferencia, setNombreCentro);

  const [
    institucionRows,
    setInstitucionPaginationStatus,
    institucionPaginationStatus,
    institucionTotalCount,
    institucionFilterStatus,
    setInstitucionFilterStatus] =
    useGetInstitucion(idEvaluacion, idDelegacion, datosPrincipales?.idInstitucion, setNombreInstitucion, initialIdInstitucion);

  const [
    financiadorRows,
    setFinanciadorPaginationStatus,
    financiadorPaginationStatus,
    financiadorTotalCount,
    financiadorFilterStatus,
    setFinanciadorFilterStatus] =
    useGetFinanciador(idEvaluacion, codigoDelegacion, datosPrincipales?.idCliente, setFinanciador);

  const [
    osSAPRows,
    setOSSAPPaginationStatus,
    osSAPPaginationStatus,
    osSAPTotalCount,
    osSAPFilterStatus,
    setOSSAPFilterStatus] =
    useGetOSSAP(idEvaluacion, codigoDelegacion, datosPrincipales?.idCliente, datosPrincipales?.idClienteSubVenta, setOSSAP);

  const [getDatosPrincipalesById, { data: dataDatosPrincipales, loading: datosPrincipalesLoading }] = useLazyQuery(GET_DATOS_PRINCIPALES_BY_ID, {
    fetchPolicy: 'no-cache'
  });

  const [getDatosPrincipalesByIdBis, { data: dataDatosPrincipalesBis }] = useLazyQuery(GET_DATOS_PRINCIPALES_BY_ID, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDatosPrincipales) return;

    const data = dataDatosPrincipales;

    if (hasInitialFinanciador === null) {
      setHasInitialFinanciador(
        !!data?.evaluacionById?.evaluacion?.idCliente
      );
    }

    setInitialIdInstitucion(
      data?.evaluacionById?.evaluacion?.idinstitucion
    );

    const adapt = adaptGetDatosPrincipales(data);
    handleChangeNDocumento(adapt.numeroDocumento);
    setDatosPrincipales(prev => ({ ...prev, ...adapt }));

    const financiadorParticular =
      adapt.codigoRamoCliente == FINANCIADOR_PARTICULAR;

    setDatosPrincipales(prev => ({
      ...prev,
      financiadorParticular,
    }));
  }, [dataDatosPrincipales]);

  const [getUltimaEval, { data: dataUltimaEval }] = useLazyQuery(GET_ULTIMA_EVALUACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataUltimaEval) return;
    const evaluacionData = adaptUltimaEvaluacion(dataUltimaEval?.ultimaEvaluacionByPaciente);
    setDatosPrincipales((prevDP) => ({
      ...prevDP,
      ...evaluacionData
    }));
  }, [dataUltimaEval]);

  const [getClienteAutorizador, { data: dataClienteAutorizador }] = useLazyQuery(GET_CLIENTE_AUTORIZADOR, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataClienteAutorizador) return;
    if (dataClienteAutorizador?.clienteAutorizador !== null) {
      setClienteAutorizado(true);
    } else {
      setClienteAutorizado(false);
    }

    if (!dataClienteAutorizador?.clienteAutorizador?.idusuario) return;
    const estadoSatisfactorioId = estadosCrediticia?.find((x) => x.displayName.includes('Satisfactorio'))?.id;
    const { gestionCrediticia } = fullFormData;
    const newGestionCrediticia = {
      ...gestionCrediticia,
      clienteCC: true,
      idEstadoCrediticio: estadoSatisfactorioId,
      fechaEstadoCrediticio: moment().format('yyyy-MM-DD HH:mm:ss')
    };
    handleChangeFullFormData('gestionCrediticia', newGestionCrediticia);
  }, [dataClienteAutorizador]);

  const [getClienteByCodigo, { data: dataClienteByCodigo }] = useLazyQuery(GET_BP_CLIENTE, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataClienteByCodigo) return;
    const bP = dataClienteByCodigo?.clienteByCodigo?.valorEsperado?.bP;
    if (bP?.trim() !== '') {
      setClienteBloqueadoPorSAP(true);
    } else {
      setClienteBloqueadoPorSAP(false);
    }
  }, [dataClienteByCodigo]);

  const [getCanal, { data: dataAllCanal }] = useLazyQuery(GET_ALL_CANAL, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataAllCanal) return;
    setCanalCombo(adaptCanalArray(dataAllCanal?.canal.valorEsperado));
  }, [dataAllCanal]);

  const [getCanalByInstitucion, { data: dataCanalByInstitucion }] = useLazyQuery(GET_CANAL_BY_INSTITUCION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataCanalByInstitucion) return;
    setUnicoCanal(dataCanalByInstitucion.canalByInstitucion?.valorEsperado.length === 1);
    if (dataCanalByInstitucion.canalByInstitucion?.valorEsperado.length <= 1) {
      getCanal();
      setCanalCombo(adaptCanalArray(dataCanalByInstitucion?.canalByInstitucion?.valorEsperado));
      handleChange('idCanal', dataCanalByInstitucion.canalByInstitucion?.valorEsperado[0]?.idCanal ?? 0);
      handleChange('detalleCanal', dataCanalByInstitucion.canalByInstitucion?.valorEsperado[0]?.detalle ?? '');
    } else {
      getCanal();
      handleChange('idCanal', 0);
      handleChange('detalleCanal', '');
    }
  }, [dataCanalByInstitucion]);

  const handleChangeImage = (name, value) => {
    obtenerDataImagen(value).then((image) => {
      handleChange(name,
        {
          contentType: image?.tipo,
          archivo: image?.data,
          extension: image?.extension,
          titulo: image?.nombre
        }
      );

      const fechaActual = moment().format("yyyy-MM-DD");

      if (name === 'derivacionPrescriptor') {
        handleChange('fechaAltaRP', fechaActual);
      }
    }).catch();
  };

  const handleRowClickCentro = (row) => {
    handleChange('idCentroReferencia', row.row.codigo);
    setNombreCentro(row.row.nombre);
  };

  const handleRowClickInstitucion = (row) => {
    setCambioDeInstitucion(true);

    if (fullFormData?.direccionPaciente?.idLugarRI === LUGAR_RI_INTERNACION_ID) {
      const datosDireccionPaciente = {
        ...fullFormData?.direccionPaciente,
        direccionInstitucion: row.row?.direccion ?? '',
        provinciaInstitucion: row.row?.provincia ?? '',
        codigoPostalInstitucion: row.row?.codigoPostal ?? '',
        localidadInstitucion: row.row?.localidad ?? ''
      };
      handleChangeDireccionPaciente(datosDireccionPaciente);
    }

    const valueAux = row.row.codigo + ' - ' + row.row.nombre;
    handleChange('idInstitucion', row.row.codigo);
    setNombreInstitucion(valueAux);

    if (datosPrincipales?.idTipoModulo)
      getCanalByInstitucion({ variables: { codigoInstitucion: row.row.codigo, idTipoModulo: datosPrincipales.idTipoModulo } });
  };

  const handleRowClickFinanciador = (row) => {
    const valueAux = row.row.codigoCliente + ' - ' + row.row.nombre;
    handleChange('idCliente', row.row.codigoCliente);
    setFinanciador(valueAux);

    const financiadorParticular = row.row?.codigoRamo == FINANCIADOR_PARTICULAR;
    setDatosPrincipales((prevDatos) => ({
      ...prevDatos,
      financiadorParticular: financiadorParticular
    }));
  };

  const handleRowClickOSSAP = (row) => {
    const valueAux = row.row.codigoCliente + ' - ' + row.row.nombre;
    handleChange('idClienteSubVenta', row.row.codigoCliente);
    setOSSAP(valueAux);
  };

  const toBase64String = (x) => {
    return btoa(x.map(function (v) { return String.fromCharCode(v); }).join(''));
  };

  const [getPacienteProbableById, { data: dataPacienteProbableById, loading: pacienteLoading }] = useLazyQuery(GET_PACIENTE_PROBABLE_BY_ID, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataPacienteProbableById) return;
    if (dataPacienteProbableById) {
      const { prePacienteById } = dataPacienteProbableById;
      const derivacionPrescriptor = prePacienteById?.idPrescripcionPacienteNavigation != null ?

        {
          contentType: prePacienteById?.idPrescripcionPacienteNavigation?.contentType,
          archivo: prePacienteById?.idPrescripcionPacienteNavigation?.imagenPerfil != null ? toBase64String(prePacienteById?.idPrescripcionPacienteNavigation?.imagenPerfil) : '',
          extension: prePacienteById?.idPrescripcionPacienteNavigation?.imagenExtension,
          titulo: prePacienteById?.idPrescripcionPacienteNavigation?.titulo
        } :
        null;

      setDatosPrincipales((prevDatos) => ({
        apellido: prePacienteById?.apellido,
        codSAPPaciente: null,
        codigoDiagnosticoTraditum: null,
        derivacionPrescriptor: derivacionPrescriptor,
        derivadorOS: false,
        familiar: prePacienteById?.nombreFamiliar,
        familiarTelefono: prePacienteById?.telFamiliar,
        fechaAlta: moment().format("yyyy-MM-DD"),
        fechaAltaRP: prePacienteById?.idPrescripcionPacienteNavigation ? moment().format("yyyy-MM-DD") : null,
        fechaNacimiento: prePacienteById?.fechaNacimiento,
        financiadorParticular: false,
        franjaEtarea: prePacienteById?.edad > 15 ? "Adulto" : "Pediátrico",
        idCentroReferencia: null,
        idCliente: prePacienteById?.idCliente,
        idClienteSubVenta: null,
        idDerivador: null,
        idDerivadorExterno: null,
        idInstitucion: prePacienteById?.codInstitucion,
        idLugarServicio: null,
        idPaciente: null,
        idTipoDocumento: prePacienteById?.idTipoDocumentoNavigation?.idTipoDocumento,
        idTipoModulo: prePacienteById?.idTipoModulo,
        mail: null,
        medioContacto: null,
        nombre: prePacienteById?.nombre,
        numeroAfiliado: prePacienteById?.nroAfiliado,
        numeroDocumento: prePacienteById?.nroDocumento,
        observaciones: null,
        identificadorPrestadorPrescriptor: null,
        responsable: null,
        sexo: prePacienteById?.sexo,
        sinDoc: false,
        telefonoContacto: prePacienteById?.telPaciente,
        telefonoMedicoContacto: null,
        tipoDerivador: null,
        observacionPrePaciente: prePacienteById?.observacion
      }));

      setNDocumentoAux(prePacienteById?.nroDocumento);
    }
  }, [dataPacienteProbableById]);

  useEffect(() => {
    if (!datosPrincipales?.fechaAlta && !datosPrincipalesLoading) {
      const fechaAltaAux = moment().format("yyyy-MM-DD");
      handleChange('fechaAlta', fechaAltaAux);
    }
  }, [idEvaluacion, datosPrincipalesLoading]);

  useEffect(() => {
    if (origen === 'US' && idEvaluacion == 0 && idPrePaciente > 0) {
      getPacienteProbableById({
        variables: {
          prepacienteId: idPrePaciente
        }
      });
    }
  }, []);

  useEffect(() => {
    if (isNew) {
      const fechaAltaAux = moment().format("yyyy-MM-DD");
      handleChange('fechaAlta', fechaAltaAux);
    }
  }, [isNew]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (deepEqualObj(fullFormData?.datosPrincipales, datosPrincipales)) return;
      handleChangeFullFormData('datosPrincipales', datosPrincipales);
    }, 100);

    return () => clearTimeout(timer);
  }, [datosPrincipales]);

  useEffect(() => {
    if (datosPrincipales?.idInstitucion && datosPrincipales?.idTipoModulo && !datosPrincipales?.idCanal)
      getCanalByInstitucion({ variables: { codigoInstitucion: datosPrincipales?.idInstitucion, idTipoModulo: datosPrincipales?.idTipoModulo } }); else
      if (!!datosPrincipales?.idCanal)
        handleChange('detalleCanal', canalCombo?.find((x) => x.id === datosPrincipales?.idCanal)?.detalle);
  }, [datosPrincipales.idTipoModulo]);

  const codigoSAP = useMemo(() => fullFormData?.direccionPaciente?.codigoSAP || null, [fullFormData?.direccionPaciente?.codigoSAP]);

  const financiadorEsTraditum = useMemo(() => requisitoCliente?.idTipoAutorizacion === ID_TIPO_AUTORIZACION_TRADITUM, [requisitoCliente?.idTipoAutorizacion]);

  // Fuera del componente — funciones puras, cada una devuelve solo los campos
  // del input que hay que actualizar (no todo el objeto, para poder mergear)

  const construirOpcionesTipoModulo = (origen, esNuevoContrato, tipoModulo) => {
    const debeExcluirSSAP = (origen == 'PP' || origen == 'PE') && esNuevoContrato;
    const modulosFiltrados = debeExcluirSSAP
      ? tipoModulo.filter((x) => x.abreviacion != 'SSAP')
      : tipoModulo;

    return modulosFiltrados.map((x) => ({ id: x.id, displayName: `${x.abreviacion} - ${x.displayName}` }));
  };

  // Mapa de configuradores por nombre de input — cada uno recibe el contexto
  // y devuelve un objeto parcial para mergear sobre el input original
  const construirConfiguradoresDeInputs = (contexto) => {
    const {
      origen,
      isNew,
      datosPrincipales,
      requisitoCliente,
      codigoSAP,
      nuevoPacienteExistente,
      lugarServicioCombo,
      tiposDocumento,
      validarDoc,
      hasInitialFinanciador,
      fullFormData,
      esNuevoContrato,
      tipoModulo,
      unicoCanal,
      canalCombo,
    } = contexto;

    const esUS = origen == 'US';
    const fechaNotifAsistencial = fullFormData.evaluacionAsistencial?.fechaNotifAsistencial;

    return {
      nombre: () => ({ disabled: esUS ? false : !isNew || !!datosPrincipales.idPaciente }),
      apellido: () => ({ disabled: esUS ? false : !isNew || !!datosPrincipales.idPaciente }),
      mail: () => ({ required: esUS ? false : requisitoCliente?.telemedicina || false }),
      telefonoContacto: () => ({ required: esUS ? false : requisitoCliente?.telemedicina || false }),
      fechaNacimiento: () => ({ disabled: esUS ? false : !!codigoSAP || nuevoPacienteExistente }),
      franjaEtarea: () => ({
        options: [
          { id: 'Adulto', displayName: 'Adulto' },
          { id: 'Pediátrico', displayName: 'Pediátrico' },
        ],
      }),
      sexo: () => ({ disabled: !!codigoSAP || nuevoPacienteExistente }),
      sinDoc: () => ({ disabled: esUS ? false : !isNew }),
      responsable: () => ({
        required: datosPrincipales.sinDoc,
        disabled: esUS ? false : !datosPrincipales.sinDoc,
      }),
      idLugarServicio: () => ({
        disabled: !!codigoSAP && !!fechaNotifAsistencial,
        options: lugarServicioCombo,
      }),
      idTipoDocumento: () => ({
        disabled: esUS ? false : !!codigoSAP || nuevoPacienteExistente,
        options: tiposDocumento,
      }),
      numeroDocumento: () => ({
        disabled: esUS ? false : !!codigoSAP || origen === 'PE',
        onBlur: () => validarDoc(),
      }),
      idCliente: () => ({
        disabled: esUS ? false : origen !== 'PE' && !isNew ? !!codigoSAP : hasInitialFinanciador,
      }),
      idClienteSubVenta: () => ({
        disabled:
          esUS
            ? false
            : datosPrincipales.financiadorParticular || !datosPrincipales.idCliente || !requisitoCliente?.subVentas,
      }),
      sinInstitucion: () => ({
        disabled: !!datosPrincipales.idCliente && !datosPrincipales.financiadorParticular,
      }),
      idInstitucion: () => ({ disabled: esUS ? false : datosPrincipales.sinInstitucion }),
      derivadorPor: () => ({ disabled: esUS ? false : datosPrincipales.derivadorOS }),
      codigoDiagnosticoTraditum: () => ({
        required: requisitoCliente?.idTipoAutorizacion === ID_TIPO_AUTORIZACION_TRADITUM,
      }),
      identificadorPrestadorPrescriptor: () => ({
        required: requisitoCliente?.idTipoAutorizacion === ID_TIPO_AUTORIZACION_TRADITUM,
      }),
      idTipoModulo: () => ({
        options: construirOpcionesTipoModulo(origen, esNuevoContrato, tipoModulo),
        disabled: !!fechaNotifAsistencial,
      }),
      derivacionPrescriptor: () => ({
        disabled: !!datosPrincipales.derivacionPrescriptor && !!fechaNotifAsistencial,
      }),
      tipoDerivador: () => ({ disabled: esUS ? false : datosPrincipales.derivadorOS }),
      idCanal: () => ({ disabled: unicoCanal, options: canalCombo }),
      observacionPrePaciente: () => ({ disabled: true }),
    };
  };

  // Aplica el configurador correspondiente a un input, o lo deja igual si no hay uno
  const aplicarConfiguracionInput = (input, configuradores, contratoEditable) => {
    const configurador = configuradores[input.name];
    const cambios = configurador ? configurador() : {};

    const inputActualizado = { ...input, ...cambios };

    if (!contratoEditable) {
      inputActualizado.disabled = true;
    }

    return inputActualizado;
  };

  // Dentro del componente:
  const validatedinputsRows = useMemo(() => {
    const configuradores = construirConfiguradoresDeInputs({
      origen,
      isNew,
      datosPrincipales,
      requisitoCliente,
      codigoSAP,
      nuevoPacienteExistente,
      lugarServicioCombo,
      tiposDocumento,
      validarDoc,
      hasInitialFinanciador,
      fullFormData,
      esNuevoContrato,
      tipoModulo,
      unicoCanal,
      canalCombo,
    });

    return structuredClone(inputsRows)
      .filter((row) => !(!financiadorEsTraditum && row.name === 'Traditum'))
      .map((row) => ({
        ...row,
        inputs: row.inputs.map((input) => aplicarConfiguracionInput(input, configuradores, contratoEditable)),
      }));
  }, [
    stepData,
    tipoModulo,
    tiposDocumento,
    contratoEditable,
    origen,
    esNuevoContrato,
    financiadorEsTraditum,
    canalCombo,
    unicoCanal,
    datosPrincipales.idInstitucion,
    datosPrincipales.idPaciente,
    datosPrincipales.sinDoc,
    datosPrincipales.financiadorParticular,
    datosPrincipales.idCliente,
    datosPrincipales.derivadorOS,
    datosPrincipales.titulo,
    datosPrincipales.sinInstitucion,
    datosPrincipales.detalleCanal,
    datosPrincipales.idCanal,
    datosPrincipales.observacionPrePaciente,
    datosPrincipales.idTipoDocumento,
    validarDoc,
    fullFormData.evaluacionAsistencial?.fechaNotifAsistencial,
    codigoSAP,
    hasInitialFinanciador,
  ]);

  useEffect(() => {
    setPageLoading(
      datosPrincipalesLoading ||
      idEvaluacion && !fullFormData.evaluacionAsistencial?.idEvaluacion ||
      lugarServicioLoading ||
      tiposDocLoading ||
      canaloading ||
      requisitoClienteLoading
    );
  }, [
    datosPrincipalesLoading,
    fullFormData.evaluacionAsistencial,
    lugarServicioLoading,
    tiposDocLoading,
    canaloading,
    requisitoClienteLoading]
  );

  useEffect(() => {
    if (datosPrincipales.sinInstitucion) {
      handleChange('idInstitucion');
      setNombreInstitucion('');
      handleChange('detalleCanal', '');
      handleChange('idCanal', 0);
      setUnicoCanal(false);
    }
  }, [datosPrincipales.sinInstitucion]);

  useEffect(() => {
    if (datosPrincipales.derivadorOS)
      handleChange('tipoDerivador');
  }, [datosPrincipales.derivadorOS]);

  useEffect(() => {
    setDataSubmissionCallback({
      callback: handleSubmit,
      validar: validarDoc
    });
  }, [datosPrincipales, setDataSubmissionCallback, validatedinputsRows]);

  const camposEspeciales = {
    buscarPacienteExistente: (input) => (
      <PacientesExistentes
        idDelegacion={idDelegacion}
        input={input}
        handleChange={handleChange}
        rows={pacientesRows}
        totalCount={pacientesTotalCount}
        filterStatus={filterStatus}
        setFilterStatus={setFilterStatus}
        handleRowClick={(row) => onSelectPacienteExistente(row.row)}
        esNuevoContrato={esNuevoContrato}
      />
    ),
    idCliente: (input) => (
      <FinanciadorInput
        idDelegacion={idDelegacion}
        input={input}
        value={financiador}
        handleChange={handleChange}
        rows={financiadorRows}
        paginationStatus={financiadorPaginationStatus}
        handleChangePaginationStatus={setFinanciadorPaginationStatus}
        totalCount={financiadorTotalCount}
        filterStatus={financiadorFilterStatus}
        setFilterStatus={setFinanciadorFilterStatus}
        handleRowClick={handleRowClickFinanciador}
      />
    ),
    idClienteSubVenta: (input) => (
      <OSSapInput
        idDelegacion={idDelegacion}
        input={input}
        value={osSAP}
        handleChange={handleChange}
        rows={osSAPRows}
        paginationStatus={osSAPPaginationStatus}
        handleChangePaginationStatus={setOSSAPPaginationStatus}
        totalCount={osSAPTotalCount}
        filterStatus={osSAPFilterStatus}
        setFilterStatus={setOSSAPFilterStatus}
        handleRowClick={handleRowClickOSSAP}
      />
    ),
    financiadorEstado: () => (
      <FinanciadorEstado
        idCliente={datosPrincipales.idCliente}
        requisitoCliente={requisitoCliente}
        clienteBloqueadoPorSAP={clienteBloqueadoPorSAP}
        clienteAutorizado={clienteAutorizado}
      />
    ),
    idCentroReferencia: (input) => (
      <CentroDeReferencia
        idDelegacion={idDelegacion}
        input={input}
        value={nombreCentro}
        handleChange={handleChange}
        rows={centrosRows}
        paginationStatus={centrosPaginationStatus}
        handleChangePaginationStatus={setCentrosPaginationStatus}
        totalCount={centrosTotalCount}
        filterStatus={centrosFilterStatus}
        setFilterStatus={setCentrosFilterStatus}
        handleRowClick={handleRowClickCentro}
      />
    ),
    idInstitucion: (input) => (
      <InstitucionInput
        idDelegacion={idDelegacion}
        input={input}
        value={nombreInstitucion}
        handleChange={handleChange}
        rows={institucionRows}
        paginationStatus={institucionPaginationStatus}
        handleChangePaginationStatus={setInstitucionPaginationStatus}
        totalCount={institucionTotalCount}
        filterStatus={institucionFilterStatus}
        setFilterStatus={setInstitucionFilterStatus}
        handleRowClick={handleRowClickInstitucion}
      />
    ),
    tipoDerivador: (input) => (
      <DerivadoInput
        handleChange={handleChange}
        input={input}
        value={derivador}
        setDerivador={setDerivador}
        idDelegacion={idDelegacion}
        idDerivador={datosPrincipales?.idDerivador}
        idDerivadorExterno={datosPrincipales?.idDerivadorExterno}
        tipoDerivador={datosPrincipales?.tipoDerivador}
      />
    ),
    numeroDocumento: (input) => (
      <RenderInputsRowByType
        input={input}
        value={origen === 'US' ? datosPrincipales?.numeroDocumento : nDocumentoAux}
        handleChange={(_, value) => handleChangeNDocumento(value)}
      />
    ),
  };

  if (pageLoading) {
    return (
      <div className='tab-loading-section-contrato'>
        <CircularProgress />
      </div>);
  }

  return <div>
    <Grid
      container
      columnSpacing={3}
      rowSpacing={3}
      columns={100}>

      {validatedinputsRows.map((row, rowIndex) =>
        <GroupedContainer key={rowIndex} ungrouped={!row.name} sectionTitle={row.name}>
          {row.inputs.map((input, index) => {
            const keyBase = input.name + input.displayName + index + '-index-row-' + rowIndex;

            if (input.type === 'file') {
              return (
                <Fragment key={keyBase}>
                  <Grid size={{ xs: 100, sm: 50, md: input.col, lg: input.col }}>
                    <RenderInputByTypeMobile
                      key={'datosPrincipales' + keyBase}
                      handleChange={handleChangeImage}
                      handleDelete={handleDelete}
                      onClickImagen={() => setOpenPreview(true)}
                      input={input}
                      value={datosPrincipales[input.name]}
                    />
                  </Grid>
                </Fragment>
              );
            }

            if (row.row === 6 || row.row === 7) {
              return (
                <Fragment key={keyBase}>
                  <RenderInputsRowByType
                    isRowWithTitle
                    key={index}
                    input={input}
                    value={datosPrincipales[input.name]}
                    handleChange={handleChange}
                  />
                </Fragment>
              );
            }

            const renderEspecial = camposEspeciales[input.name];

            return (
              <Fragment key={keyBase}>
                {renderEspecial
                  ? renderEspecial(input)
                  : <RenderInputsRowByType
                    key={index}
                    input={input}
                    value={datosPrincipales[input.name]}
                    handleChange={handleChange}
                  />}
              </Fragment>
            );
          })}
        </GroupedContainer>
      )}
    </Grid>
    <CustomDialog
      open={openPacExistenteModal}
      title='El documento se encuentra asignado a otro paciente'
      onAccept={onAcceptPacExistente}
      onCancel={onDeclinePacExistente}
      cancelText='Cerrar'>

      El documento se encuentra asignado al paciente <strong>{pacienteExistente?.nombre || ''} {pacienteExistente?.apellido || ''}</strong>,
      delegación <strong>{pacienteExistente?.nameDelegacion}</strong>
      <br />
      ¿Desea cargar los datos del paciente?
    </CustomDialog>

    {openPreview && <DocumentViewerBase64 data={datosPrincipales.derivacionPrescriptor} setOpenDlg={setOpenPreview} download={true} />}
  </div>;
};

//#region CustomHooks
const useGetPacientes = (idDelegacion, origen) => {
  const [allPacientes, setAllPacientes] = useState([]);
  const [filterStatus, setFilterStatus] = useState('');

  const filterValue = useDebounce(filterStatus.toLowerCase(), 500);

  const filteredPacientes = useMemo(() => {

    const inputBuscar = normalizeFilterValue(filterValue);

    if (inputBuscar.length) {
      return allPacientes?.filter((pacienteOriginal) => {
        const nombre = pacienteOriginal.nombre.toString().toUpperCase();
        const apellido = pacienteOriginal.apellido.toUpperCase();
        const numeroDocumento = pacienteOriginal.numeroDocumento.toUpperCase();
        return (
          nombre.includes(inputBuscar) ||
          apellido.includes(inputBuscar) ||
          numeroDocumento.includes(inputBuscar));

      }) || [];

    } else {
      return allPacientes;
    }
  }, [allPacientes, filterValue]);

  const [getPacientes, { data: dataPacientes, loading: allPacientesLoading }] = useLazyQuery(GET_PACIENTES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataPacientes) return;
    setAllPacientes(dataPacientes.allPacientesFromContrato.valorEsperado);
  }, [dataPacientes]);

  useEffect(() => {
    if (!allPacientesLoading) {
      getPacientes({
        variables: {
          estado: origen === 'PP' ? 'AT' : 'MAT',
          idDelegacion: idDelegacion
        }
      });
    }
  }, [idDelegacion]);

  return [
    filteredPacientes,
    filteredPacientes?.length || 0,
    filterStatus,
    setFilterStatus];

};

const useGetCentros = (idContrato, idDelegacionParam, idCentro, setCentro) => {
  const [centros, setCentros] = useState([]);

  const adaptedCentros = useMemo(() => adaptCentrosArray(centros?.items) || [], [centros]);

  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 5,
    page: 0
  });

  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getCentrosDeReferencia, { loading: centrosLoading }] = useLazyQuery(GET_ALL_INSTITUCIONES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    let alive = true;

    if (!idCentro) return;

    const getInstitucionSelected = async () => {
      try {
        const res = await getCentrosDeReferencia({
          variables: {
            skip: 0,
            take: 1,
            where: {
              cod_Institucion: { eq: idCentro }
            }
          }
        });

        if (!alive) return; // evita AbortError

        const items = res?.data?.allInstitucionesPaginated?.items;
        if (items && items.length > 0) {
          const centro = adaptInstitucion(items[0]);
          const newValue = `${centro.codigo} - ${centro.nombre}`;
          setCentro(newValue);
        }
      } catch (error) {
        if (error?.name !== "AbortError") {
          console.error("Error al obtener institución:", error);
        }
      }
    };

    getInstitucionSelected();

    return () => {
      alive = false;
    };
  }, [idCentro]);

  useEffect(() => {
    if (!centrosLoading) {
      getCentrosDeReferencia({
        variables: {
          skip: paginationStatus.page * paginationStatus.pageSize,
          take: paginationStatus.pageSize,
          where: {
            and: [
              idDelegacionParam !== null && idDelegacionParam !== undefined ? { institucionDelegacion: { some: { idDelegacion: { eq: idDelegacionParam } } } } : {},
              {
                or: [
                  { nombre: { contains: debouncedFilterValue?.trim() } },
                  { nombreFantasia: { contains: debouncedFilterValue?.trim() } },
                  { cod_Institucion: { contains: debouncedFilterValue?.trim() } }]

              }]

          }
        }
      }).then((res) => {
        setCentros(res?.data?.allInstitucionesPaginated);
      }).catch((error) => {
        if (error?.name === "AbortError") return; // ignorar abortos
        console.error("Error en getInstituciones:", error);
      });
    }
  }, [paginationStatus, debouncedFilterValue, idContrato, idDelegacionParam]);

  return [
    adaptedCentros,
    setPaginationStatus,
    paginationStatus,
    centros?.totalCount,
    filterStatus,
    setFilterStatus];

};
const useGetInstitucion = (idContrato, idDelegacionParam, idInstitucion, setNombreInstitucion, initialIdInstitucion) => {
  const [instituciones, setInstituciones] = useState([]);

  const adaptedInstituciones = useMemo(() => adaptInstitucionesArray(instituciones?.items) || [], [instituciones]);

  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 5,
    page: 0
  });

  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getInstituciones, {
    data: dataInstituciones,
    loading: institucionesLoading
  }] = useLazyQuery(GET_ALL_INSTITUCIONES, {
    fetchPolicy: 'no-cache'
  });

  const [getInstitucionById, {
    data: dataInstitucionById
  }] = useLazyQuery(GET_ALL_INSTITUCIONES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!idInstitucion) return;

    const row = adaptedInstituciones.find((x) => x.codigo === idInstitucion);
    if (row) {
      const newValue = `${row.codigo} - ${row.nombre}`;
      setNombreInstitucion(newValue);
      return;
    }

    getInstitucionById({
      variables: {
        skip: 0,
        take: 1,
        where: {
          cod_Institucion: { eq: idInstitucion }
        }
      }
    });
  }, [idInstitucion, adaptedInstituciones, getInstitucionById]);

  useEffect(() => {
    if (!dataInstitucionById?.allInstitucionesPaginated) return;

    if (dataInstitucionById.allInstitucionesPaginated.totalCount > 0) {
      const institucion = adaptInstitucion(dataInstitucionById.allInstitucionesPaginated.items[0]);
      const newValue = `${institucion.codigo} - ${institucion.nombre}`;
      setNombreInstitucion(newValue);
    }
  }, [dataInstitucionById, setNombreInstitucion]);

  useEffect(() => {
    getInstituciones({
      variables: {
        skip: paginationStatus.page * paginationStatus.pageSize,
        take: paginationStatus.pageSize,
        where: {
          and: [
            !initialIdInstitucion ? { activo: { eq: true } } : {},
            idDelegacionParam !== null && idDelegacionParam !== undefined
              ? { institucionDelegacion: { some: { idDelegacion: { eq: idDelegacionParam } } } }
              : {},
            {
              or: [
                { nombre: { contains: debouncedFilterValue?.trim() } },
                { nombreFantasia: { contains: debouncedFilterValue?.trim() } }
              ]
            }
          ]
        }
      }
    });
  }, [paginationStatus, debouncedFilterValue, idContrato, idDelegacionParam, initialIdInstitucion, getInstituciones]);

  useEffect(() => {
    if (institucionesLoading) return;

    if (dataInstituciones?.allInstitucionesPaginated) {
      setInstituciones(dataInstituciones.allInstitucionesPaginated);
    }
  }, [dataInstituciones, institucionesLoading]);

  return [
    adaptedInstituciones,
    setPaginationStatus,
    paginationStatus,
    instituciones?.totalCount,
    filterStatus,
    setFilterStatus
  ];
};

const useGetFinanciador = (idContrato, codigoDelegacion, idCliente, setFinanciador) => {

  const [financiadores, setFinanciadores] = useState([]);

  const adaptedFinanciadores = useMemo(() => adaptFinanciadoresArray(financiadores?.allClientesPaging?.items) || [], [financiadores]);

  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 5,
    page: 0
  });

  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getFinanciadores, { loading: financiadoresLoading }] = useLazyQuery(GET_ALL_CLIENTES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!idCliente)
      return;

    const row = adaptedFinanciadores.find((x) => x.codigoCliente === idCliente);
    if (!!row) {
      const newValue = row.codigoCliente + ' - ' + row.nombre;
      setFinanciador(newValue);
      return;
    }

    const getFinanciadorSelected = async () => {
      const getNewCliente = await getFinanciadores({
        variables: {
          skip: 0,
          take: 1,
          where: {
            cod_Cliente: { eq: idCliente }
          }
        }
      }).then((res) => {
        if (res?.data?.allClientesPaging?.items !== null && res?.data?.allClientesPaging?.items.length > 0) {
          const cliente = adaptFinanciador(res?.data?.allClientesPaging?.items[0]);
          const newValue = cliente.codigoCliente + ' - ' + cliente.nombre;
          setFinanciador(newValue);
        }
      }).catch((error) => {
        if (error?.name === "AbortError") return; // ignorar abortos
        console.error("Error en getInstituciones:", error);
      });
    };
    getFinanciadorSelected();
  }, [idCliente]);

  useEffect(() => {
    if (!financiadoresLoading) {
      getFinanciadores({
        variables: {
          skip: paginationStatus.page * paginationStatus.pageSize,
          take: paginationStatus.pageSize,
          where: {
            and: [
              codigoDelegacion !== null && codigoDelegacion !== undefined ? { cod_Delegacion: { eq: codigoDelegacion } } : {},
              {
                or: [
                  { cod_Cliente: { contains: debouncedFilterValue?.trim() } },
                  { nom_com: { contains: debouncedFilterValue?.trim() } }]

              }]

          }
        }
      }).then((res) => {
        setFinanciadores(res?.data);
      }).catch((error) => {
        if (error?.name === "AbortError") return; // ignorar abortos
        console.error("Error en getInstituciones:", error);
      });
    }
  }, [paginationStatus, debouncedFilterValue, idContrato, codigoDelegacion]);

  return [
    adaptedFinanciadores,
    setPaginationStatus,
    paginationStatus,
    financiadores?.allClientesPaging?.totalCount,
    filterStatus,
    setFilterStatus];

};

const useGetOSSAP = (idContrato, codigoDelegacion, idFinanciador, idOsSAP, setNombreOSSAP) => {
  const [osSAP, setOSSAP] = useState([]);

  const adaptedOSSAP = useMemo(() => adaptFinanciadoresArray(osSAP?.allClientesPaging?.items?.filter((x) => x.cod_Cliente !== idFinanciador)) || [], [osSAP, idFinanciador]);

  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 5,
    page: 0
  });

  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getFinanciadores, { loading: financiadoresLoading }] = useLazyQuery(GET_ALL_CLIENTES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!idOsSAP)
      return;

    const row = adaptedOSSAP.find((x) => x.codigoCliente === idOsSAP);
    if (!!row) {
      const newValue = row.codigoCliente + ' - ' + row.nombre;;
      setNombreOSSAP(newValue);
      return;
    }

    const getFinanciadorSelected = async () => {
      const getNewCliente = await getFinanciadores({
        variables: {
          skip: 0,
          take: 1,
          where: {
            cod_Cliente: { eq: idOsSAP }
          }
        }
      }).then((res) => {
        if (res?.data?.allClientesPaging?.items !== null) {
          const cliente = adaptFinanciador(res?.data?.allClientesPaging?.items[0]);
          const newValue = cliente.codigoCliente + ' - ' + cliente.nombre;
          setNombreOSSAP(newValue);
        }
      }).catch((error) => {
        if (error?.name === "AbortError") return; // ignorar abortos
        console.error("Error en getInstituciones:", error);
      });
    };
    getFinanciadorSelected();
  }, [idOsSAP]);

  useEffect(() => {
    if (!financiadoresLoading) {
      getFinanciadores({
        variables: {
          skip: paginationStatus.page * paginationStatus.pageSize,
          take: paginationStatus.pageSize,
          where: {
            and: [
              codigoDelegacion !== null && codigoDelegacion !== undefined ? { cod_Delegacion: { eq: codigoDelegacion } } : {},
              idFinanciador !== null && idFinanciador !== undefined ? { cod_Cliente: { neq: idFinanciador } } : {},
              {
                or: [
                  { cod_Cliente: { contains: debouncedFilterValue?.trim() } },
                  { nom_com: { contains: debouncedFilterValue?.trim() } }]

              }]

          }
        }
      }).then((res) => {
        setOSSAP(res?.data);
      }).catch((error) => {
        if (error?.name === "AbortError") return; // ignorar abortos
        console.error("Error en getInstituciones:", error);
      });
    }
  }, [paginationStatus, debouncedFilterValue, idContrato, codigoDelegacion]);

  return [
    adaptedOSSAP,
    setPaginationStatus,
    paginationStatus,
    osSAP?.allClientesPaging?.totalCount,
    filterStatus,
    setFilterStatus];

};

const useValidateDni = (
  handleChangeDocumentoReal,
  idPaciente,
  onSelectPacienteExistente,
  handleChangeOrigen,
  idDelegacion,
  setIsDistinctDelegacion,
  idTipoDocumento) => {
  const [nDocumentoAux, setNDocumentoAux] = useState('');
  const [openPacExistenteModal, setOpenPacExistenteModal] = useState(false);
  const [pacienteExistente, setPacienteExistente] = useState(false);

  const [checkDni] = useLazyQuery(VALIDATE_EXIST_PACIENTE_BY_DNI, {
    fetchPolicy: 'no-cache'
  });
  const [checkPacientePE] = useLazyQuery(VALIDATE_PACIENTE_PE, {
    fetchPolicy: 'no-cache'
  });
  const [checkPacientePP] = useLazyQuery(VALIDATE_PACIENTE_PP, {
    fetchPolicy: 'no-cache'
  });

  const handleChangeNDocumento = (value) => {
    handleChangeDocumentoReal(value);
    setNDocumentoAux(value);
  };

  const onDeclinePacExistente = () => {
    setNDocumentoAux('');
    handleChangeDocumentoReal('');
    handleCloseModal();
  };

  const onAcceptPacExistente = async () => {
    const res = await checkPacientePE({
      variables: {
        idPaciente: parseInt(pacienteExistente.idPaciente)
      }
    });

    if (!!pacienteExistente?.codSAPPaciente && !!res.data?.validatePacientePE) {
      handleChangeOrigen('PE');
    }

    if (parseInt(idDelegacion) !== parseInt(pacienteExistente.idDelegacion)) {
      setIsDistinctDelegacion(true);
      toast.error('Para avanzar, cambie la delegación del paciente, ya que no coincide con la delegación actual.', { duration: 6000 });
      return;
    }

    onSelectPacienteExistente(pacienteExistente);

    handleCloseModal();
  };

  const handleOpenModal = () => setOpenPacExistenteModal(true);
  const handleCloseModal = () => setOpenPacExistenteModal(false);

  const validarDoc = async (newIdTipoDocumento) => {
    setIsDistinctDelegacion(false);

    if (!nDocumentoAux) return true;

    try {
      const res = await checkDni({
        variables: {
          idPaciente: parseInt(idPaciente) || null,
          dni: nDocumentoAux?.toString(),
          idTipoDocumento: newIdTipoDocumento || idTipoDocumento
        }
      });

      const paciente = res?.data?.validateExistPacienteByDni;

      if (paciente) {
        setPacienteExistente(adaptPaciente(paciente));
        handleOpenModal();
        return false; // ❌ No dejar continuar, ya existe
      } else {
        handleChangeDocumentoReal(nDocumentoAux?.toString());
        return true; // ✅ Validado OK, continuar
      }
    } catch (err) {
      console.error("Error al validar DNI:", err);
      return false;
    }
  };

  return [
    pacienteExistente,
    nDocumentoAux,
    openPacExistenteModal,
    handleChangeNDocumento,
    onAcceptPacExistente,
    onDeclinePacExistente,
    validarDoc,
    setNDocumentoAux];

};
//#endregion
//#region Inputs
const inputsRows = [
  {
    row: 11,
    inputs: [
      {
        col: 80,
        name: 'item',
        type: 'item'
      },
      {
        displayName: 'F. de Ingreso',
        name: 'fechaAlta',
        type: 'date',
        disabled: true,
        col: 20
      }]

  },
  {
    row: 1,
    name: 'Paciente',
    inputs: [
      {
        displayName: 'Nombre',
        name: 'nombre',
        type: 'string',
        required: true,
        disabled: true,
        col: 25
      },
      {
        displayName: 'Apellido',
        name: 'apellido',
        type: 'string',
        required: true,
        disabled: true,
        col: 25
      },
      {
        displayName: 'Buscar paciente existente',
        name: 'buscarPacienteExistente',
        disabled: false,
        type: 'button',
        col: 25
      },
      {
        col: 25,
        name: 'item',
        type: 'item'
      },
      {
        displayName: 'Email',
        name: 'mail',
        type: 'string',
        required: false,
        col: 25
      },
      {
        displayName: 'Teléfono Contacto Paciente',
        name: 'telefonoContacto',
        required: true,
        type: 'string',
        col: 25
      },
      {
        displayName: 'Ej. +54 (Cod. área) número de teléfono',
        name: 'texttext',
        type: 'text',
        col: 50
      },
      // --------
      {
        displayName: 'Fecha de Nacimiento',
        name: 'fechaNacimiento',
        type: 'date',
        required: true,
        disabled: true,
        disableFuture: true,
        col: 25
      },
      {
        displayName: 'Franja etaria',
        name: 'franjaEtarea',
        disabled: true,
        type: 'select',
        col: 20
      },
      {
        displayName: 'Sexo',
        name: 'sexo',
        type: 'button_options',
        required: true,
        disabled: true,
        fitContent: true,
        options: [
          { id: 'F', displayName: 'F' },
          { id: 'M', displayName: 'M' }],

        col: 12
      },
      {
        displayName: 'Sin Doc.',
        name: 'sinDoc',
        disabled: true,
        labelPlacement: 'start',
        sx: { justifyContent: 'center' },
        type: 'check',
        col: 10
      },
      {
        displayName: 'Nombre y apellido del tutor',
        name: 'responsable',
        required: false,
        disabled: true,
        type: 'string',
        col: 30
      },
      //------------
      {
        displayName: 'Tipo de documento*',
        name: 'idTipoDocumento',
        type: 'button_options',
        disabled: true,
        fitContent: true,
        options: [],
        col: 25
      },
      {
        displayName: 'Numero de Doc',
        name: 'numeroDocumento',
        required: true,
        disabled: true,
        type: 'string',
        maxLength: 10,
        col: 25
      },
      {
        displayName: 'N° de afiliado',
        name: 'numeroAfiliado',
        required: true,
        type: 'string',
        col: 30
      },
      //----------
      {
        displayName: 'Familiar a cargo',
        name: 'familiar',
        required: true,
        type: 'string',
        col: 25
      },
      {
        displayName: 'Teléfono Familiar a cargo',
        name: 'familiarTelefono',
        required: true,
        type: 'string',
        col: 25
      },
      {
        displayName: 'Lugar de prestación de servicio',
        name: 'idLugarServicio',
        required: true,
        disabled: true,
        type: 'select',
        col: 30
      }]

  },
  {
    row: 2,
    name: 'Financiador',
    inputs: [
      {
        displayName: 'Financiador particular',
        name: 'financiadorParticular',
        type: 'check',
        disabled: true,
        labelPlacement: 'start',
        sx: { justifyContent: 'start', ml: 0 },
        col: 20
      },
      {
        displayName: 'Financiador SAP (El que paga)',
        name: 'idCliente',
        disabled: true,
        type: 'search',
        col: 35
      },
      {
        displayName: '',
        name: 'financiadorEstado',
        type: 'search',
        col: 3
      },
      {
        name: 'item',
        type: 'item',
        col: 1
      },
      {
        displayName: 'OS SAP',
        name: 'idClienteSubVenta',
        required: true,
        disabled: true,
        type: 'search',
        col: 35
      }]

  },
  {
    row: 3,
    name: 'Derivación',
    inputs: [
      {
        displayName: 'Sin institución',
        name: 'sinInstitucion',
        type: 'check',
        labelPlacement: 'start',
        sx: { justifyContent: 'start', ml: 0 },
        col: 14
      },
      {
        displayName: 'Institución',
        name: 'idInstitucion',
        required: true,
        disabled: true,
        type: 'search',
        col: 26
      },
      {
        displayName: 'Profesional de cabecera',
        name: 'tipoDerivador',
        required: true,
        disabled: true,
        type: 'search',
        col: 40
      },
      // --------
      {
        displayName: 'Canal',
        name: 'idCanal',
        disabled: true,
        type: 'select',
        col: 30
      },
      {
        displayName: 'Detalle Canal',
        name: 'detalleCanal',
        disabled: true,
        type: 'string',
        col: 60
      }]

  },
  {
    row: 4,
    name: 'RP',
    inputs: [
      {
        displayName: 'Adjuntar RP',
        name: 'derivacionPrescriptor',
        required: true,
        disabled: true,
        type: 'file',
        isDesktop: true,
        col: 30
      },
      {
        displayName: 'Fecha de alta de (RP)',
        name: 'fechaAltaRP',
        disabled: true,
        type: 'date',
        col: 20
      }]

  },
  {
    row: 5,
    name: 'Programa',
    inputs: [
      {
        displayName: 'Programa de asistencia al paciente',
        name: 'idTipoModulo',
        required: true,
        disabled: true,
        type: 'select',
        options: [],
        col: 25
      },
      {
        displayName: 'Centro de referencia',
        name: 'idCentroReferencia',
        required: true,
        type: 'search',
        col: 25
      },
      {
        displayName: 'Profesional de contacto',
        name: 'medicoContacto',
        required: false,
        type: 'string',
        col: 25
      },
      {
        displayName: 'Teléfono Profesional Contacto',
        name: 'telefonoMedicoContacto',
        required: false,
        type: 'string',
        col: 25
      }]

  },
  {
    row: 6,
    name: 'Traditum',
    inputs: [
      {
        displayName: 'Cod. Diagnostico Traditum',
        name: 'codigoDiagnosticoTraditum',
        required: true,
        type: 'string',
        col: 25
      },
      {
        displayName: 'Prestador Prescriptor',
        name: 'identificadorPrestadorPrescriptor',
        required: true,
        type: 'int',
        col: 25
      }]

  },
  {
    row: 11,
    inputs: [
      {
        displayName: 'Observación PrePaciente',
        name: 'observacionPrePaciente',
        type: 'long_string',
        col: 100
      },
      {
        displayName: 'Observaciones Asistenciales',
        name: 'observaciones',
        required: false,
        type: 'long_string',
        col: 100
      }]

  }];

//#endregion

const calcularEdad = (fechaNacimiento) => {
  const nacimiento = moment(fechaNacimiento, 'YYYY-MM-DD');
  const hoy = moment();
  const edad = hoy.diff(nacimiento, 'years');
  return edad || 0;
};